var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_750_1029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5437 13.8563C16.5437 18.2554 13.0081 21.8217 8.64697 21.8217C4.28585 21.8217 0.75 18.2546 0.75 13.8563C0.75 9.45791 4.28558 5.89062 8.64697 5.89062C13.0084 5.89062 16.5437 9.45711 16.5437 13.8563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2056 13.8565C25.2056 17.9973 23.4378 21.3555 21.2571 21.3555C19.0764 21.3555 17.3086 17.9973 17.3086 13.8565C17.3086 9.7156 19.0761 6.35742 21.2568 6.35742C23.4375 6.35742 25.2053 9.71452 25.2053 13.8565",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7498 13.8547C28.7498 17.5639 28.1281 20.5726 27.3611 20.5726C26.594 20.5726 25.9727 17.5647 25.9727 13.8547C25.9727 10.1447 26.5943 7.13672 27.3611 7.13672C28.1279 7.13672 28.7498 10.1444 28.7498 13.8547Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_750_1029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.75 0.0566406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumNegative);
export default __webpack_public_path__ + "static/media/medium-negative.26432ebdbea9a9ad707b13cfe635966c.svg";
export { ForwardRef as ReactComponent };